import { throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { postRequestInit } from '@/queries/utils';
import { LocatieVoorEenheden, LocatieVoorEenhedenPostObject } from '@/types/LocatieVoorEenheden';

const useDefectLocatiesApi = (throwOnInvalidResponse = false) => {
  const { fetchWithAuth } = useFetchWithAuth();
  const getLocatiesVoorEenheden = async (eenheden: string[]): Promise<LocatieVoorEenheden[]> => {
    if (!eenheden.length || eenheden[0] === '') {
      return [];
    }
    const tijd = new Date().toISOString();
    const requestBody = {
      tijd,
      eenheden: Array.from(new Set(eenheden))
        .filter((eenheid) => eenheid !== 'MANCO')
        .join(','),
    } as LocatieVoorEenhedenPostObject;

    const response = await fetchWithAuth('/werklijnen/dienstregelpunten', postRequestInit(requestBody));
    if (!response.ok) {
      if (!throwOnInvalidResponse) {
        return [];
      }
      throwIfResponseNotOk(response, `Ophalen van defectlocaties is mislukt (${response.status}).`);
    }

    const responseData: unknown = await response.json();

    if (!Array.isArray(responseData)) {
      if (throwOnInvalidResponse) {
        throw new Error('Ongeldig antwoord van defectlocaties API');
      }
      return [];
    }

    return responseData as LocatieVoorEenheden[];
  };

  return {
    getLocatiesVoorEenheden,
  };
};
export default useDefectLocatiesApi;
